// extracted by mini-css-extract-plugin
module.exports = {"inputVan":"_1PT83sNL","labelVan":"_2FlAenux"};